import { createFileRoute } from '@tanstack/react-router';
import { JourneysWizardStepHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';

/** The legacy preview URL, which this app claims only to forward to the migrated one. */
function JourneysImportPreviewRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWizardStepHandoff step="preview" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview',
)({
  validateSearch: validateWizardSearch,
  component: JourneysImportPreviewRoute,
});
